import React from 'react';
import styles from './NoNetworkScreen.module.css';

const NoNetworkScreen = () => {
  return (
    <div className={styles.noNetworkContainer}>
      <div className={styles.icon}>📡</div>
      <h2>No Internet Connection</h2>
      <p>Please check your network and try again.</p>
    </div>
  );
};

export default NoNetworkScreen;
